export const keyZipCodeStr = "@FC:Ecom:Dropdown:Cep";
export const keyRegionLocation = "@FC:Ecom:Dropdown:Region";
export const cookieBranchLocationStr = "@FC:Ecom:Dropdown:BranchLocation";
export const cookieAccessToken = "@FC:Ecom:Token:Access";
export const SECTIONS_ITEMS_MENU = [
  {
    description: "Sobre o Produto",
    idReference: "AboutTheProduct",
  },
  {
    description: "Ficha técnica",
    idReference: "ProductSpec",
  },
  {
    description: "Veja Também",
    idReference: "AlsoSee",
  },
];

export const LIST_ENVIRONMENT_DEFAULT = -1;
